import { render, staticRenderFns } from "./MdTableClaimBatch.vue?vue&type=template&id=2fd737c5&"
import script from "./MdTableClaimBatch.vue?vue&type=script&lang=js&"
export * from "./MdTableClaimBatch.vue?vue&type=script&lang=js&"
import style0 from "./MdTableClaimBatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports